import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import SyntaxHighlighter from 'react-syntax-highlighter';
// @ts-expect-error TS7016: Could not find a declaration file for module
import * as hljs from 'react-syntax-highlighter/styles/hljs';
import { Button } from 'reactstrap';
import { withHandleActivateTrial } from '../../../components/hoc/WithHandleActivateTrial';
import Icon from '../../../components/Icon';
import NumericSummary from './NumericSummary';
export const ClearFilterReport = (props) => {
    const { t } = useTranslation();
    const { errorsLeft, warningsLeft, showTrial, file, generated, handleActivateTrial, trialActivateable, onClick, isCommitTimedOut = false, } = props;
    const handleClick = () => {
        onClick();
        window.scrollTo(0, 0);
    };
    return _jsxs("div", { children: [_jsxs("div", { className: clsx('report-detail__item', generated || !file && 'report-detail__item--generated'), children: [_jsx("span", { className: "float-right report-detail__item-issue-count", children: _jsx(NumericSummary, { errorCount: errorsLeft, warningCount: warningsLeft, iconFixedWidth: true }) }), _jsxs("h3", { className: "report-detail__file-path", children: [_jsx(Icon, { name: "file-code", className: "report-detail__icon mr-2" }), _jsxs("bdi", { children: [file ? file.filePath : '.codeac/more-issues.md', file && !generated ? null : (_jsxs("small", { className: "ml-1", children: ["(", t('generated').toLocaleLowerCase(), ")"] }))] })] }), _jsx("div", { className: "report-detail__code--placeholder", children: _jsx(SyntaxHighlighter, { language: "markdown", style: {
                                ...hljs.solarizedLight,
                                hljs: {
                                    ...hljs.solarizedLight.hljs,
                                    padding: void 0,
                                },
                            }, showLineNumbers: true, wrapLines: true, className: "report-detail__code", lineNumberContainerStyle: {
                                borderRight: '0.0625rem solid #999',
                                color: '#999',
                                marginRight: '1rem',
                                paddingLeft: '1rem',
                                paddingRight: '10px',
                                textAlign: 'right',
                                float: 'left',
                            }, children: t(showTrial ? 'expandFilterTrial' : 'expandFilter') }) })] }), showTrial ? (_jsx("div", { className: "btn-wrapper text-center", children: trialActivateable ? (_jsx(Button, { color: "secondary", size: "md", onClick: handleActivateTrial, children: t('settings.tryPro', { siteName: t('siteName') }) })) : (_jsx(Link, { to: "/settings/billing", className: "btn btn-secondary", children: t('availableInPro') })) })) : (!isCommitTimedOut && _jsx("div", { className: "btn-wrapper text-center", style: {
                    position: 'absolute',
                    minWidth: '100%',
                    marginTop: '-5rem',
                    left: '50%',
                    transform: 'translate(-50%, 0)',
                }, children: _jsx(Button, { color: "secondary", size: "lg", onClick: handleClick, children: t('showRemainingIssues', {
                        count: errorsLeft + warningsLeft,
                        formattedCount: new Intl.NumberFormat(t('numberFormatLocale')).format(errorsLeft + warningsLeft),
                    }) }) }))] });
};
export default withHandleActivateTrial(ClearFilterReport);
